import React from 'react';
export const RightArrowSvg: React.FC = () => {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 10 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 17L8.29289 9.70711C8.68342 9.31658 8.68257 8.68257 8.29204 8.29204C5.59393 5.59393 3.88028 3.88028 0.999999 1"
        stroke="#4D525E"
        strokeWidth="2"
      />
    </svg>
  );
};
